import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { FeedbackCount } from '@/model/Analytics';
import { FeedbackGoodIcon, FeedbackBadIcon } from '@/assets/svgs/icons';


interface FeedbackCardBodyProps {
    counts: FeedbackCount[];
    total: number;
}

const FeedbackCardBody: React.FC<FeedbackCardBodyProps> = ({ counts, total }) => {
    const intl = useIntl();

    const [goodFeedback, badFeedback] = useMemo(() => {
        return [
            counts.filter(feedback => feedback.rating === "good"),
            counts.filter(feedback => feedback.rating === "bad")
        ];
    }, [counts]);

    const regionLabel = intl.formatMessage({ id: "i01013" });
    return (
        <div className="px-4 size-full flex flex-col"
             role="region"
             aria-label={regionLabel}
        >
            <FeedbackContent title={intl.formatMessage({ id: "i01015" })}
                             count={goodFeedback.length}
                             total={total}
                             icon={<FeedbackGoodIcon className="size-4.5 text-chat42" aria-hidden="true" />}
            />

            <hr className="mt-[58px] mb-[29px] w-full border-black-200" />

            <FeedbackContent title={intl.formatMessage({ id: "i01016" })}
                             count={badFeedback.length}
                             total={total}
                             icon={<FeedbackBadIcon className="size-4.5 text-chat42" aria-hidden="true" />}
            />
        </div>
    );
};


interface FeedbackContentProps {
    icon: React.ReactNode;
    title: string;
    count: number;
    total: number;
}

const FeedbackContent: React.FC<FeedbackContentProps> = ({ icon, title, count, total }) => {
    const intl = useIntl();

    return (
        <div className="w-full flex flex-col gap-[26px]">
            <div className="w-full flex items-center gap-3">
                <div className="size-[32px] flex items-center justify-center rounded-full bg-chat42-10">
                    {icon}
                </div>
                <div className="text-[14px] font-[600] leading-none text-black-500">
                    {title}
                </div>
            </div>
            <div className="w-full flex flex-col justify-center items-center gap-3">
                {count > 0
                    ? (<>
                        <div className="text-[18px] font-[600] leading-none text-black-500">
                            {count.toLocaleString()}
                        </div>
                        <div className="text-[12px] font-[400] leading-none text-black-500">
                            {`(${(total ? (count / total * 100).toFixed(0) : 0)}%)`}
                        </div>
                    </>) : (
                        <div className="mt-2 text-[14px] font-[400] leading-none text-black-400">
                            {intl.formatMessage({ id: "i01018" })}
                        </div>
                    )}
            </div>
        </div>
    );
};

export default FeedbackCardBody;
